import React from 'react';

export const Badge = ({ type, text }) => {
  const styles = {
    critical: 'bg-red-500/20 text-red-500 border-red-500/30',
    high: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    medium: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    low: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    secure: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    vulnerable: 'bg-red-500/20 text-red-500 border-red-500/30',
    warning: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    passed: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    failed: 'bg-red-500/20 text-red-500 border-red-500/30',
  };

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-mono border ${styles[type] || styles.low}`}>
      {text || type.toUpperCase()}
    </span>
  );
};